import React from "react"
import { Button, Stack } from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"

export const EditProfileButtons = ({ loading, disabled, handleSubmit, handCancel }) => {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} justifyContent={'flex-end'} mt={4}>
      <Button
        variant="outlined"
        sx={{ width: { xs: '100%', sm: '250px' } }}
        onClick={() => handCancel()}
      >
        Cancel
      </Button>
      <LoadingButton
        onClick={() => handleSubmit()}
        size="small"
        loading={loading}
        variant="contained"
        disabled={loading || disabled}
        sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }}
      >
        Save Changes
      </LoadingButton>
    </Stack>
  )
};